import { Component, OnInit } from '@angular/core';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';
import { CompressionService } from '../compression.service';
import * as shape from 'd3-shape';

@Component({
  selector: 'app-t-letter-decompression',
  templateUrl: './t-letter-decompression.component.html',
  styleUrls: ['./t-letter-decompression.component.css']
})
export class TLetterDecompressionComponent extends GeneralTeacherComponent {
  mapping: string[][] = [["", ""], ["", ""], ["", ""], ["", ""]];

  get map0(): string[] {
    return this.mapping.map(v => v[0]);
  }

  get map1(): string[] {
    return this.mapping.map(v => v[1]);
  }

  text: string;
  modus: string;
  showTree: boolean = false;
  compressedText: string = "";
  undecompressableText: string = "";
  decodingPossible: boolean = true;

  nodes: any[];
  edges: any[];

  view: any[] = undefined;
  fitContainer: boolean = true;
  curve = shape.curveBundle;

  constructor(topicService: TopicService, activatedRoute: ActivatedRoute, protected compressionService: CompressionService) {
    super(topicService, activatedRoute)
    this.type = "letterDecompression";
    this.title = this.get("letterDecompression");
  }

  setInformationWithConfiguration() {
    super.setInformationWithConfiguration();
    this.compressedText = this.configuration.typespecifics.text;
    this.mapping = this.configuration.typespecifics.mapping;
    this.modus = this.configuration.typespecifics.modus;
    this.text = this.compressionService.decompressLetter(this.compressedText, this.mapping);
    if (this.text == "") {
      this.decodingPossible = false;
      this.undecompressableText = this.compressedText;
    }
    this.showTree = this.modus == "tree";
    if (!this.notFilled() && !this.notUnique()) {
      let graph = this.compressionService.computeTree(this.mapping);
      this.nodes = graph.nodes;
      this.edges = graph.edges;
    }
  }

  generateDefinition() {
    let definition: any = {};
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    definition.title = this.title;
    definition.type = this.type;
    definition.description = this.description;
    definition.image = "./assets/images/letterDecompression.png";
    definition.level = 2;
    definition.key = "compression%".concat(this.type, "%");
    if (this.examId > -1) {
      definition.key = definition.key.concat("exam%", this.examId.toString(), "%");
    }
    definition.typespecifics = {};
    definition.typespecifics.text = this.decodingPossible ? this.compressedText.trim() : this.undecompressableText;
    definition.typespecifics.mapping = this.mapping;
    definition.typespecifics.modus = this.showTree ? "tree" : "mapping";
    definition.key = definition.key.concat("%", this.text, "%", this.mapping.toString());

    return definition;
  }

  generate() {
    this.title = this.get("letterDecompression");
    this.decodingPossible = true;
    this.mapping = [];
    let count = Math.floor(Math.random() * 4) + 4;
    let sum = 0;
    let alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
    let codes = this.compressionService.getCodes(count);
    for (let i = 0; i < count; i++) {
      let char = alphabet.splice(Math.floor(Math.random() * alphabet.length), 1).toString();
      let code = codes.splice(Math.floor(Math.random() * codes.length), 1);
      this.mapping.push([char, code.toString()]);
    }

    let chars = this.map0;
    let length = Math.ceil(Math.random() * 5) + 5;
    this.text = "";
    for (let i = 0; i < length; i++) {
      this.text = this.text.concat(chars[Math.floor(Math.random() * chars.length)])
    }
    this.normalizeMapping(0);
    this.showTree = Math.random() > 0.5;
  }

  reset() {
    super.reset();
    this.decodingPossible = true;
    this.title = this.get("letterDecompression");
    this.mapping = [["", ""], ["", ""], ["", ""], ["", ""]];
    this.showTree = false;
    this.text = "";
    this.normalizeText();
  }

 
  /** normalize the text to only contain letter of the mapping */
  normalizeText() {
    if (this.text) {
      let allowed = this.mapping.map(v => v[0]);
      this.text = this.text.replace(new RegExp("[^" + allowed + "]", 'gi'), '').replace(/\s+/gi, ' ').toUpperCase();
      this.compressedText = this.compressionService.compressLetter(this.text, this.mapping);
    }
  }

  /** normalize the mapping and update the graph */
  normalizeMapping(i: number) {
    this.mapping[i][0] = this.mapping[i][0].toUpperCase().replace(/[^A-Z]/gi, "").charAt(0);
    this.mapping[i][1] = this.mapping[i][1].toUpperCase().replace(/[^01]/gi, "");
    this.normalizeText();
    if (!this.notFilled() && !this.notUnique()) {
      let graph = this.compressionService.computeTree(this.mapping);
      this.nodes = graph.nodes;
      this.edges = graph.edges;
    }
  }

   /** delete the given letter from the mapping */
   deleteMapping(i: number) {
    this.mapping.splice(i, 1);
    this.normalizeText();
    if (!this.notFilled() && !this.notUnique()) {
      let graph = this.compressionService.computeTree(this.mapping);
      this.nodes = graph.nodes;
      this.edges = graph.edges;
    }
  }

   /** are all letters and codes unique? */
   notUnique(): boolean {
    if (this.map0.filter((v, i) => this.map0.indexOf(v) != i).length > 0 || this.map1.filter((v, i) => this.map1.indexOf(v) != i).length > 0) {
      return true;
    }
    return false;
  }

  /** are all codes filled in? */
  notFilled(): boolean {
    if (this.map1.filter(v => v == undefined || v.trim() == "").length > 0) {
      return true;
    }
    return false;
  }

 /** is the encoding prefix free? */
 notPrefixFree(): boolean {
    for (let i = 0; i < this.map1.length; i++) {
      for (let j = 0; j < i; j++) {
        if (this.map1[i].startsWith(this.map1[j]) || this.map1[j].startsWith(this.map1[i])) {
          return true;
        }
      }
    }
    return false;
  }

 /** are all letters filled in? */
 notEnough(): boolean {
    if (this.map0.filter(v => v == undefined || v.trim() == "").length > 0) {
      return true;
    }
    return false;
  }

  /** generate a text which can not be decompressed */
  generateUndecompressable() {
    let codes = this.compressionService.getCodes(20);
    let chars = this.map0;
    let length = Math.ceil(Math.random() * 5) + 5;
    let text = "";
    for (let i = 0; i < length; i++) {
      text = text.concat(chars[Math.floor(Math.random() * chars.length)])
    }
    let position = Math.ceil(Math.random() * length);
    let part1 = this.compressionService.compressLetter(text.substring(0, position), this.mapping);
    let part2 = this.compressionService.compressLetter(text.substring(position, text.length), this.mapping);
    for (let code of codes) {
      this.undecompressableText = part1.concat(code, part2);
      if (this.compressionService.decompressLetter(this.undecompressableText, this.mapping) == "") {
        return;
      }
    }
    this.undecompressableText = "";
  }
}
